// extracted by mini-css-extract-plugin
export var container = "_98-0";
export var icon = "_98-1";
export var text = "_98-2";